import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';

// Extended Appiya Component
import HowitworksExtended from './components-flow/HowitworksExtended';

const FlowPage = () => {
  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title="導入の流れ"
        subtitle="お問い合わせから納品まで、透明性の高いプロセスでプロジェクトを成功に導きます"
        breadcrumb="導入の流れ"
      />

      {/* 導入フロー詳細 - Appiyaコンポーネント使用 */}
      <HowitworksExtended data={protoaiData.flow} />
    </div>
  );
};

export default FlowPage;